// extracted by mini-css-extract-plugin
export default {"album-card-title":"styles_album-card-title__Jwphb"};